<template>
  <div class="bb-refund-credit-notes">
    <div v-for="(soaCreditNote, index) in soaCreditNotes"
         :key="soaCreditNote.id"
         v-if="index <= limitCount"
         class="bb-refund-credit-notes-container"
    >
      <div class="bb-refund-credit-notes-container__item"
           @click.stop="openProforma(soaCreditNote)"
      >
        Tax Credit Note {{soaCreditNote.number}}
      </div>
      <div v-if="index === limitCount && countAddedCreditNotes !== 0"
           class="bb-refund-credit-notes-more"
           ref="iconPopup"
           @click="openPopup($event)"
      >
        <span class="bb-refund-credit-notes-more__item">
          and {{countAddedCreditNotes}} more
        </span>
        <transition name="bounce">
          <div class="bb-refund-credit-notes-popup"
               :style="popupPosition"
               v-if="showPopup">
            <div class="bb-refund-credit-notes-popup__item"
                 v-for="remainingCreditNote in remainingCreditNotes"
                 :key="remainingCreditNote.id"
                 @click.stop="openProforma(remainingCreditNote)"
            >
              Tax Credit Note {{remainingCreditNote.number}}
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RefundCreditNotes',
  props: ['limitCount', 'soaCreditNotes', 'fixedPopup'],
  computed: {
    countAddedCreditNotes () {
      return this.soaCreditNotes.length - this.limitCount - 1
    },
    remainingCreditNotes () {
      return this.soaCreditNotes.slice(this.limitCount + 1)
    }
  },
  data () {
    return {
      showPopup: false,
      popupPosition: {}
    }
  },
  methods: {
    openProforma (item) {
      this.$emit('openTaxCreditNote', item)
    },
    openPopup (e) {
      this.showPopup = !this.showPopup
      if (this.showPopup) this.setPositionPopup(e)
    },
    setPositionPopup (e) {
      if (this.fixedPopup) {
        const box = e.target.getBoundingClientRect()
        this.popupPosition = {
          left: (box.left) + 'px',
          top: box.top + 30 + 'px'
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../../../../../../sass/variables";
  @import "../../../../../../../sass/mixins";

  .bb-refund-credit-notes {
    position: relative;
    max-width: 192px;
    width: 100%;
    display: inline-flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;

    &-more {
      padding-top: 4px;
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 14px;
      color: $color-denim;
      cursor: pointer;
      transition: .3s;
      user-select: none;

      &__item {
        &:hover {
          opacity: 0.8;
        }
      }
    }

    &-container {
      padding-top: 4px;

      &__item {
        cursor: pointer;
        transition: 0.3s;

        &:hover {
          color: $color-accent;
        }
      }

      &:first-child {
        padding-top: 0;
      }
    }

    &-popup {
      position: fixed;
      padding: 12px 12px;
      background-color: $color-white;
      color: $color-black;
      list-style: disc inside;
      font-weight: normal;
      font-size: 12px;
      line-height: 14px;
      box-shadow: 0 0 20px rgba($color-black, 0.1);
      border-radius: 5px;
      z-index: 12;
      opacity: 1;
      display: grid;
      grid-gap: 4px;

      &__item {
        cursor: pointer;
        transition: 0.3s;

        &:hover {
          color: $color-accent;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/RefundHandovers/RefundHandoversList/RefundCreditNotes.vue